// export const main_end_point = "http://18.190.131.19" 
export const main_end_point = "https://inseta.kabakoo.africa" 
export const ticket_anonyme_end_point = "https://portfoliodevapi.kabakoo.africa/api/send_anonymous_ticket_message/"

